export const RECEIVE_IS_PRIORITY = "RECEIVE_IS_PRIORITY";
export const LOYALTY_SDK_FAILURE = "LOYALTY_SDK_FAILURE";
export const ITEM_STATE_IS_PRIORITY = "ITEM_STATE_IS_PRIORITY";
